import {Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';

/**
 * Cette directive permet d'éviter la prise d'un événement du dom
 * Privilégier cette directive dans les composants plutot que d'ajouter l'attribut directement sur le composant
 * pour faciliter la maintenance.
 */
@Directive({
  selector: '[wizNotFocusable]'
})
export class WizNotFocusableDirective {

  /* wizDomEventListen
  *  dom event that triggers EventEmitter
  */
  @Input() wizDomEventListen: string = 'click';

  /* WizEvent
  * Allows the execution of a callback
  */
  @Output() wizEvent: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param elRef: the dom of the component
   * @param renderer: object that will allow the interaction between the component and the DOM
   */
  constructor(private elRef: ElementRef, private renderer: Renderer2) {

    // tabindex est un entier indiquant si l'élément peut capturer le focus
    this.renderer.setAttribute(this.elRef.nativeElement, 'tabindex', '-1');

    // Garder le code au cas ou l'on souhaiterais venir faire un traitement particulier sur un événement précis
    // Add for dom events
    // this.elRef.nativeElement.addEventListener('click', e => this.stopEvents(e), true);
    // this.elRef.nativeElement.addEventListener('mousedown', e => this.stopEvents(e), true);
    // this.elRef.nativeElement.addEventListener('mouseup', e => this.stopEvents(e), true);
    // this.elRef.nativeElement.addEventListener('focus', e => this.stopEvents(e), true);
  }

  /*
  * Stop events
  * Cette méthode permet de stopper la propagation d'évenement et de le réattribuer via un le wizEvent
  */
  private stopEvents(e: Event): void {
    // interface prevents other listeners of the same event from being called.
    e.stopImmediatePropagation();
    // tells the user agent that if the event does not get explicitly handled, its default action should not be taken as it normally would be.
    e.preventDefault();
    //  prevents further propagation of the current event in the capturing and bubbling phases.
    e.stopPropagation();

    if (e.type === this.wizDomEventListen) {
      // dispatch event emitter
      this.wizEvent.next(e);
    }
  }
}
